import React from "react";
import Card from "./Card";
import Filters from "./Filters";
import List from "./List";
import ListItem from "./ListItem";
import { useMapContext } from "./MapContext";
import IconList from "../icons_js/List.js";
import IconFilter from "../icons_js/Filter.js";
export default function SideBar() {
  const {
    providerMarkers,
    openCard,
    setOpen,
    setShowFilter,
    showFilter,
    showList,
    setShowList,
  } = useMapContext();
  return (
    <div style={{}}>
      <div
        style={{
          width: 300,
          position: "absolute",
          left: 0,
          top: 0,
          height: "100%",
          overflowX: "visible",
          display: "flex",
          flexDirection: "column",
          flexGrow: 0,
          flexShrink: 0,
          zIndex: 1001,
          background: "white",
          transform: showFilter ? "translateX(0)" : "translateX(-100%)",
          transition: "all 100ms ease-out",
          boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
        }}
      >
        <div
          style={{
            background: "white",
            display: "flex",
            justifyContent: "end",
          }}
        >
          <a
            href="#Filter"
            onClick={(e) => {
              e.preventDefault();
              setShowFilter(false);
            }}
            style={{
              position: "relative",
              background: "white",
              zIndex: 0,
              padding: "10px 20px",
              fontSize: 20,
              fontWeight: 900,
            }}
          >
            ✕
          </a>
        </div>
        <div
          style={{
            padding: `0 12px`,
          }}
        ></div>
        <Filters />
      </div>
      <div
        style={{
          width: 400,
          maxWidth: "calc(100% - 60px)",
          position: "absolute",
          left: 0,
          top: 0,
          height: "100%",
          overflowX: "visible",
          flexGrow: 0,
          flexShrink: 0,
          zIndex: 1000,
          transform: showFilter
            ? "translateX(200px)"
            : showList
            ? "translateX(0)"
            : "translateX(-100%)",
          transition: "all 100ms ease-out",
          boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <a
          href="#List"
          onClick={(e) => {
            e.preventDefault();
            setShowList(!showList);
            setShowFilter(false);
          }}
          style={{
            position: "absolute",
            bottom: 25,
            left: "100%",
            background: "white",
            zIndex: 5000,
            padding: "15px 15px",
            borderTopRightRadius: 2,
            borderBottomRightRadius: 2,
            boxShadow: "rgb(0 0 0 / 30%) 2px 1px 4px -1px",
            lineHeight: 0,
          }}
        >
          <IconList style={{ width: 25, height: 25 }} />
        </a>
        <div
          style={{
            background: "white",
            display: "flex",
            justifyContent: "start",
            boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
            position: "relative",
            zIndex: 1,
          }}
        >
          <a
            href="#Filter"
            onClick={(e) => {
              e.preventDefault();
              setShowFilter(!showFilter);
            }}
            style={{
              position: "relative",
              background: "white",
              padding: "10px 20px",
              display: "flex",
              gap: 10,
            }}
          >
            <IconFilter style={{ width: 20, height: 20 }} /> Filter
          </a>
        </div>
        <List>
          {providerMarkers.length > 0 ? (
            providerMarkers.map((provider) => {
              return (
                <ListItem
                  key={provider.key}
                  provider={provider}
                  setOpen={setOpen}
                  openCard={openCard}
                />
              );
            })
          ) : providerMarkers.length == 0 ? (
            <span style={{ padding: 20 }}>Keine Einträge gefunden</span>
          ) : (
            <span style={{ padding: 20 }}>Lade Liste...</span>
          )}
        </List>
      </div>
      <div
        style={{
          width: 400,
          maxWidth: "95%",
          position: "absolute",
          left: 0,
          top: 0,
          height: "100%",
          overflowX: "visible",
          flexGrow: 0,
          flexShrink: 0,
          zIndex: 1000,
          transform: openCard ? "translateX(0)" : "translateX(-100%)",
          transition: "all 100ms ease-out",
          boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
          background: "white",
        }}
      >
        <Card provider={openCard} onClose={() => setOpen(null)} />
      </div>
    </div>
  );
}
